import { helpers, selectors } from 'app-webtech-core';
import { ccMenuSetIndex } from 'app-modules/player/actions';
import { END } from './types';

const remoteControllerEndButtonAction = helpers.actions.actionCreator(END);

export const remoteControllerEndButtonThunkAction = () => async (dispatch, getState) => {
  await dispatch(remoteControllerEndButtonAction());
  const state = getState();
  const { isCCMenuOpen, currentCCMenu } = selectors.player.properties(state);

  // checks to see if the cc settings menu is open
  if (isCCMenuOpen) {
    const lastIndex = currentCCMenu.length - 1;
    if (currentCCMenu.length > 1) {
      // Goes to the last menu item
      dispatch(ccMenuSetIndex(lastIndex));
    }
  }
};
